import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataTestDirective } from './data-test.directive';

@NgModule({
  declarations: [DataTestDirective],
  imports: [CommonModule],
  exports: [DataTestDirective],
})
export class DataTestModule {}
